module.exports = __webpack_public_path__ + "img/ic_32_workout_intensity-low.732419cc.svg";